<template>

  <div class="container">
    <div class="row">
      <div class="col">

        <div class="sidenav">
          <a id="categoria" class="link-sidenav" @click="cambioOption('categoria')">Categorias</a>
          <a id="contacto" class="link-sidenav" @click="cambioOption('contacto')">Contactos</a>
          <a id="noticia" class="link-sidenav" @click="cambioOption('noticia')">Noticias</a>
          <a id="producto" class="link-sidenav" @click="cambioOption('producto')">Productos</a>
<!--          <a id="usuario" class="link-sidenav" @click="cambioOption('usuario')">Usuario</a>-->
        </div>

      </div>
    </div>

  </div>


</template>

<script>
import {useStore} from "vuex";

export default {
  name: "SideBar",
  setup(){
    const store = useStore();


    const cambioOption = (opcion) => {
      store.dispatch("cambiarOption", opcion)
    }


    return {
      cambioOption
    }




  }
}
</script>

















<style scoped>

@font-face {
  font-family: Jose Thin;
  src: url('../assets/fonts/JosefinSans-Thin.ttf');
}

@font-face {
  font-family: Josefin Sans;
  src: url('../assets/fonts/JosefinSans-Regular.ttf');
}

.link-sidenav {
  font-family: "Josefin Sans";
}


.sidenav {
  margin-top: 9vh;
  height: 100%;
  width: 160px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  padding-top: 20px;
}

.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #bebbbb;
  display: block;
}

.sidenav a:hover {
  cursor: pointer;
}

#categoria:hover {
  color: #37acff;
}


#contacto:hover {
  color: #37ffee;
}

#noticia:hover {
  color: #9e37ff;
}

#producto:hover {
  color: #ff7337;
}

#usuario:hover {
  color: #ffc037;
}


.main {
  margin-left: 160px; /* Same as the width of the sidenav */
  font-size: 28px; /* Increased text to enable scrolling */
  padding: 0px 10px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

</style>